module.exports = __webpack_public_path__ + "static/img/img3.2f356fd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/help/img3.png
// module id = Z7FI
// module chunks = 1